export const getNextElement = (
  elements: (HTMLLIElement | null)[] | undefined,
  next: boolean
): HTMLLIElement | null => {
  if (!elements) {
    return null
  }
  const activeElement = document.activeElement
  const count = elements.length
  const currentIndex = elements.findIndex(ref => {
    return ref?.contains(activeElement)
  })

  if (currentIndex !== -1) {
    let nextIndex = next ? currentIndex - 1 : currentIndex + 1
    if (nextIndex < 0) {
      nextIndex = count - 1
    } else if (nextIndex >= count) {
      nextIndex = 0
    }

    if (nextIndex !== -1) {
      return elements[nextIndex]
    }
  }
  return null
}
